import React from 'react'
import { Link } from 'react-router-dom'
import { useNavigate, useParams } from "react-router-dom"
import { BaseUrl } from '../../helper/BaseUrl';
import { DateConvert } from '../../helper/DateConvert';
import { Accordion } from 'react-bootstrap'
import GlobalFaq from '../../components/GlobalFaq';
export default function BlogDetailContent({ initialData }) {
   const { slug } = useParams();
   const [aiData, setAiData] = React.useState(initialData || {});
   const [pageUrl, setPageUrl] = React.useState("");
   const [copied, setCopied] = React.useState(false);

   const navigate = useNavigate();
   React.useEffect(() => {
      if (typeof window !== "undefined") {
         setPageUrl(window.location.href);
      }
   }, []);
   const handleCopy = async () => {
      if (typeof window !== "undefined" && pageUrl) {
         try {
            await navigator.clipboard.writeText(pageUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 10000); // reset after 10s
         } catch (err) {
            console.error("Copy failed:", err);
         }
      }
   };
   const aifetcher = async () => {
      try {
         const response = await fetch(`${BaseUrl}/api/blog/view/${slug}`, {
            method: 'GET',
         });
         const result = await response.json();
         if (result.blog === false) {
            navigate("/404");
            throw new Error(`API error: ${result.message}`);
         }
         setAiData(result.blog);
      } catch (error) {
         console.error('Fetch error:', error.message);
      }
   };
   React.useEffect(() => {
      aifetcher();
   }, [slug])
   const handleScroll = (id) => {
      const element = document.getElementById(id);
      if (element) {
         const yOffset = -90; // 👈 offset from top (90px)
         const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
         window.scrollTo({
            top: y,
            behavior: "smooth",
         });
      }
   };
   return (
      <>
         <section className="blogdetail-content-area">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <ul className="dynamic-breadcrumb">
                        <li> <Link to={"/"}> Home</Link></li>
                        <li> <Link to={"/blog"}> Blog</Link></li>
                        <li> <Link> {aiData?.title ? aiData.title.slice(0, 20) + "..." : ""}</Link>  </li>
                     </ul>
                     <div className="blog-detail-head">
                        <h1 className="heading">  {aiData?.title} </h1>
                        <div className="blog-detail-user-wrap">
                           <div className="blog-detail-user">
                              <img src={aiData?.author_image ? BaseUrl + aiData?.author_image : "/assets/images/author-images.webp"} alt={aiData?.author_name} className="img-responsive" />
                              <div> <span>{"Written by " + aiData?.author_name}</span>  <small>{DateConvert(aiData?.date)}</small>   </div>
                           </div>
                           <div className="blog-detail-social">
                              <ul>
                                 <li title={copied ? "Copied!" : "Copy link"}>
                                    <Link to="#" onClick={handleCopy} rel="noopener noreferrer" >   <i className="fa-solid fa-link"></i> </Link>
                                 </li>
                                 <li>
                                    <Link to={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(pageUrl)}`} target="_blank" rel="noopener noreferrer"> <i className="fa-brands fa-linkedin-in"></i></Link>
                                 </li>
                              </ul>
                           </div>
                        </div>
                        <img src={aiData?.banner_image ? BaseUrl + aiData.banner_image : undefined} className="img-responsive blog-detail-banner-img" alt={aiData?.title} />
                     </div>
                  </div>
               </div>
               <div className="row">
                  <div className="col-lg-9 col-md-9 order-1 order-md-0">
                     <div className="blog-detail-text">
                        <div dangerouslySetInnerHTML={{ __html: aiData?.introduction }} />
                        {aiData?.full_description && aiData?.full_description?.map((data, index) => (
                           <div key={index}>
                              <h2 className="heading" id={`section-${index}`}> {data?.heading}  </h2>
                              <div dangerouslySetInnerHTML={{ __html: data?.description }} />
                              {index === 1 && aiData?.image1 && (
                                 <div className="ai-blog-wrap">  <img src={aiData?.image1 ? BaseUrl + aiData.image1 : undefined} alt={aiData?.alt_image1} className="img-responsive" loading="lazy" />  </div>
                              )}
                           </div>
                        ))}
                        {aiData?.reference &&
                        <div className="reference-wrap">
                           <Accordion id="references">
                              <Accordion.Item eventKey="0">
                                 <Accordion.Header as={"h2"}>{"References"}</Accordion.Header>
                                 <Accordion.Body>
                                    <div dangerouslySetInnerHTML={{ __html: aiData?.reference }} />
                                 </Accordion.Body>
                              </Accordion.Item>
                           </Accordion>
                           </div>
                        }
                        <div className="blog-deatil-btn">
                           <ul>  {aiData?.tags && aiData.tags.split(",").map((tag, index) => (
                              <li key={index}>  <Link>  {tag.trim()} </Link>  </li>
                           ))}
                           </ul>
                        </div>

                        <GlobalFaq/>

                     </div>
                  </div>
                  {/* ===== Right Sidebar ===== */}
                  <div className="col-lg-3 col-md-3 order-0 order-md-1">
                     <div className="blog-details-navigation">
                        <div className="navigation-right">
                           <label>Content</label>
                           <ul>
                              {aiData?.full_description && aiData?.full_description?.map((data, index) => (
                                 <li key={index}>
                                    <a onClick={() => handleScroll(`section-${index}`)}>
                                       {data?.heading?.length > 40
                                          ? data?.heading?.slice(0, 40) + "..."
                                          : data?.heading}
                                    </a>
                                 </li>
                              ))}
                           </ul>

                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section >
      </>
   )
}
